export const versions = {
  version: "1.0.183",
  revision: "2b2be266e",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5167-g2b2be266e-dirty",
    hash: "g2b2be266e",
    distance: 5167,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5167-g2b2be266e-dirty",
    semverString: "1.0.183+5167.g2b2be266e.dirty"
  }
};
